import React from "react";
import { injectIntl } from "react-intl"
import { BaseDistributedColumn } from ".";
import { bradenScaleRangeStyles, getEpoch } from "_metronic/_helpers";

export interface BradenMonitoringsDistributedColumnData {
  scales: Array<number>
  total: number
}
export interface BradenMonitoringsDistributedColumnProps {
  intl: any
  data?: BradenMonitoringsDistributedColumnData
  width?: number
  height?: number
}
function BradenMonitoringsDistributedColumn(props: BradenMonitoringsDistributedColumnProps) {
  const { intl, data, width, height } = props
  const [newSignal, setNewSignal] = React.useState<number>(0)
  
  const [labels] = React.useState<Array<string>>([
    intl.formatMessage({ id: "REPORTS.BRADEN.RANGE.EMPTY" }),
    intl.formatMessage({ id: "REPORTS.BRADEN.RANGE.VERY_LOW" }),
    intl.formatMessage({ id: "REPORTS.BRADEN.RANGE.LOW" }),
    intl.formatMessage({ id: "REPORTS.BRADEN.RANGE.MEDIUM" }),
    intl.formatMessage({ id: "REPORTS.BRADEN.RANGE.HIGH" }),
    intl.formatMessage({ id: "REPORTS.BRADEN.RANGE.VERY_HIGH" }),
  ])
  const [colors] = React.useState<Array<string>>([
    '#575757',
    '#19bffe',
    '#19fe40',
    '#e6ec1c',
    '#fea919',
    '#fe1919'
  ])

  const onDataSerie = () => {
    if (!data) return null

    return data?.scales.reduce((p, c) => {
      const scaleInfo = bradenScaleRangeStyles(c)
      
      p[scaleInfo.index]++
      return p
    }, new Array(labels.length).fill(0))
  }

  React.useEffect(() => {
    setNewSignal(getEpoch())
  }, [data])

  return (
    <BaseDistributedColumn
      width={width ?? '100%'} 
      height={height ?? '100%'}
      id='braden-monitorings'
      title={intl.formatMessage({id: "REPORTS.BRADEN.RANGE.TITLE"})}
      sortTitle={intl.formatMessage({id: "REPORTS.BRADEN.RANGE.SORT.TITLE"})}
      modalTitleId={"REPORTS.BRADEN.RANGE.TITLE"}
      modalBodyTextId={"REPORTS.BRADEN.RANGE.DETAILS"}
      colors={colors}
      labels={labels}
      onDataSerie={onDataSerie}
      newDataSignal={newSignal}
      />
  )
}
export default injectIntl((BradenMonitoringsDistributedColumn))
